import { Play } from "lucide-react";
import { ytThumb } from "../../data/projects";

export const MediaCard = ({ title, id, url, caption }) => (
  <a
    href={url}
    target="_blank"
    rel="noopener noreferrer"
    data-testid={`media-card-${id}`}
    className="card-hover block bg-white overflow-hidden no-underline"
    style={{ border: "1px solid var(--border-default)", borderRadius: 10, color: "inherit", textDecoration: "none" }}
  >
    <div className="relative">
      <img src={ytThumb(id)} alt={title} loading="lazy" className="w-full object-cover" style={{ aspectRatio: "16 / 9" }} />
      <span
        aria-hidden="true"
        className="absolute inset-0 m-auto flex items-center justify-center"
        style={{ width: 48, height: 48, borderRadius: "50%", background: "rgba(255,255,255,0.92)", color: "var(--navy-700)" }}
      >
        <Play size={20} fill="currentColor" />
      </span>
    </div>
    <div className="p-4">
      <h4 className="text-h4 mb-1">{title}</h4>
      {caption && <p className="caption m-0">{caption}</p>}
    </div>
  </a>
);
